import { getNow } from "./fp";

export const createQuestion = (question: string, meta: any) => ({
  question,
  ...meta,
  createdAt: getNow(),
});

